<template>
  <transition name="el-fade-in-linear">
  <div v-show="transitionshow">     
      <el-form :inline="true" class="backborder1 demo-form-inline" size="small">
          <el-form-item style="width:28%">
          	  <el-date-picker v-model="query.date" type="datetimerange" range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期" value-format="yyyy-MM-dd HH:mm:ss" :unlink-panels="false" style="width:100%" @change="ischange=true"></el-date-picker>
          </el-form-item>
          <el-form-item style="width:13%">
              <el-select v-model="query.searchtype" remote filterable @change="ischange=true" style="width:100%">
                  <el-option v-for="(item,index) in searchtype" :label="item.name" :value="item.id" :key="index"></el-option>
              </el-select>   
          </el-form-item>
          <el-form-item style="width:14%">
              <el-input placeholder="请输入关键字" v-model="query.key" clearable @keyup.enter.native="getawardlists" @change="ischange=true" style="width:100%"></el-input>
          </el-form-item>
          <el-form-item>
              <el-button type="primary" icon="el-icon-search" @click="getfundlists" style="with:100%">查询</el-button>
              <el-button type="primary" icon="el-icon-search" @click="exportfundlists" style="with:100%">导出</el-button>
          </el-form-item>
          <el-form-item style="width:100%;">
              <div style="color:#909399">
                  <span>用户可提现金额：<i style="font-style:normal;color:rgb(230, 162, 60);font-weight:bold">￥{{wallet}}</i></span>
              </div>
          </el-form-item>   
      </el-form>
     
      <div class="backborder2" style="margin-top:10px">
	      <el-table :data="lists" v-loading="listsloading">
	          <el-table-column prop="out_sn" label="流水单号"></el-table-column>
              <el-table-column prop="username" label="用户名称" width="130"></el-table-column>
              <el-table-column prop="shopname" label="所属店铺" width="150"></el-table-column>
              <el-table-column prop="amount" label="提现金额" width="110" align="center"></el-table-column>
              <el-table-column prop="account" label="提现账号" width="120" align="center"></el-table-column>
              <el-table-column prop="reason" label="提现原因" width="110" align="center"></el-table-column>
              <el-table-column prop="inputtime" label="提现时间" width="170" align="center"></el-table-column>
          </el-table>

          <div class="block">
	          <!--分页begin-->
	          <el-pagination
	            @size-change="drawspageChange"
	            @current-change="drawspageCurrentChange"
	            :current-page="query.p"
	            :page-sizes="[10, 20, 50]"
	            :page-size="query.rollpage"
	            layout="total, sizes, prev, pager, next, jumper"
	            :total="rows">
	          </el-pagination>
	          <!--分页end-->
          </div>
      </div>

      <!---------------------------- 导出信息确认 ---------------------------->
	  <el-dialog title="导出信息确认" :visible.sync="outputDialog" width="98%" top="5vh">
	      	  <el-button size="medium" type="danger" @click="sureoutput" style="float:right;margin-right:0;margin-bottom:15px">确认导出</el-button>
	      	  <div id="outputorder">
		      	  <el-table :data="outlists" border v-loading="outlistsLoading">
		      	  	  <el-table-column prop="out_sn" label="流水单号"></el-table-column>
                      <el-table-column prop="username" label="用户名称" width="130"></el-table-column>
                      <el-table-column prop="shopname" label="所属店铺" width="150"></el-table-column>
                      <el-table-column prop="amount" label="提现金额" width="110" align="center"></el-table-column>
                      <el-table-column prop="account" label="提现账号" width="120" align="center"></el-table-column>
                      <el-table-column prop="reason" label="提现原因" width="110" align="center"></el-table-column>
                      <el-table-column prop="inputtime" label="提现时间" width="170" align="center"></el-table-column>	  	          	  
		      	  </el-table>
	      	  </div>
	      	  <div slot="footer" class="dialog-footer">
		          <el-button size="medium" @click="outputDialog=false">取 消</el-button>
		          <el-button size="medium" type="danger" @click="sureoutput">确认导出</el-button>
		      </div>	                
	  </el-dialog> 
          
  </div>
  </transition> 
</template>

<script>

export default {
  data () {
    return {
      url:this.GLOBAL.domain+"Draws/index",
      transitionshow:true,
      query: {
          act:'packetfundlists',
          token:this.$cookies.get('token'),
          date:[],
          searchtype:1,
          key:'',
          isexport:0,
          p:1,
          rollpage:10
      },
      ischange:false,
      lists:[],
      rows:0,
      listsloading:false,
      searchtype:[
          {id:1,name:'流水单号'},
          {id:2,name:'用户名称'},
          {id:3,name:'提现账号'},
          {id:4,name:'店铺名称'}
      ],
      outlistsLoading:false,
      outputDialog:false,
      outlists:[],
      wallet:0.00,

    }  
  },
  mounted(){
     this.getfundlists();
     this.getwallet();
  },
  methods:{

      /** 获取可提现金额 **/
      getwallet() {
          var resource = this.$resource(this.url);
          resource.query({act:'getwallet',token:this.$cookies.get('token')}).then((res) => {
              if(res.data.Result>0){
                  if(res.data.Result=='70001') this.$router.push('/login')
                  this.$message.error(res.data.Message);
              }else{
                  var result = JSON.parse(Base64.decode(res.data.Data));
                  this.wallet=result.wallet;
              }
          }).catch((res) => {
              
          });
      },

      /** 获取活动信息 **/
      getfundlists() {
          if(this.ischange==true) {this.query.p=1;this.query.rollpage=10;}
          this.listsloading=true;
          this.query.isexport=0;
          var resource = this.$resource(this.url);
          resource.query(this.query).then((res) => {
              if(res.data.Result>0){
                  if(res.data.Result=='70001') this.$router.push('/login')
                  this.$message.error(res.data.Message);
                  this.listsloading=false;
              }else{
                  this.lists = JSON.parse(Base64.decode(res.data.Data));
	              this.rows=parseInt(res.data.count);
                  if(this.ischange==true) this.ischange=false;
                  this.listsloading=false;
              }
          }).catch((res) => {
              this.listsloading=false;
          });
      },

      drawspageChange(val) {
        this.query.rollpage = val;
        this.getfundlists();
      },
      drawspageCurrentChange(val) {
        this.query.p = val;
        this.getfundlists();
      },
      
      /** 导出提现信息 **/
      exportfundlists() {
        this.outlistsLoading=true;
        this.outputDialog=true;
        var resource = this.$resource(this.GLOBAL.exportUrl+"Draws/index");
        this.query.isexport=1;
        resource.save(this.query).then((res) => {
            if(res.data.Result>0){
                if(res.data.Result=='70001') this.$router.push('/login')
                this.$message.error(res.data.Message);
                this.outlistsLoading=false;
            }else{
                this.outlists = JSON.parse(Base64.decode(res.data.Data));
                this.outlistsLoading=false;
            }
        }).catch((res) => {
            this.$message.error(this.GLOBAL.errortext);
            this.outlistsLoading=false;
        });
      },
      
      /** 确认导出订单信息 **/
      sureoutput() {
		  require.ensure([], () => {
			  var { export_json_to_excel } = require('../../vendor/Export2Excel');
			  var tHeader = ['流水单号','用户名称','所属店铺','提现金额','提现账号','提现原因','提现时间'];
			  var filterVal = ['out_sn','username','shopname','amount','account','reason','inputtime'];
				
			  var list = this.outlists;
			  var data = this.formatJson(filterVal, list);
			  export_json_to_excel(tHeader, data, '抽奖红包提现记录');
			  this.outputDialog=false;
		  })
      },
    
      //导出表格数据
	  formatJson(filterVal, jsonData) {
　　　　  return jsonData.map(v => filterVal.map(j => v[j]));
　　  },
      

  }
}
</script>
<style>
.backborder1 {background:#fff;border-radius:15px;border:1px solid #ddd;padding:1% 1% 1% 1%}
.backborder2 {background:#fff;border-radius:15px;border:1px solid #ddd;padding:0 1% 3% 1%}
</style>


// WEBPACK FOOTER //
// src/components/mall/packetfund.vue